import { Card, PageHeader } from '../components/ui';

const PLAN: Record<string, string> = {
  M2: 'Barcode + การนับแบบ Online: สแกน (เครื่องสแกน/กล้อง), บันทึก Barcode ระหว่างนับ, รอบการนับ, แปลงหน่วย, Void และหน้าตรวจยอด',
  M3: 'Offline + Sync: นับได้แม้ไม่มีเน็ต, ส่งข้อมูลอัตโนมัติเมื่อกลับมา Online, รวมยอดหลายเครื่อง',
  M4: 'รายงาน + Export Excel/CSV และทดสอบใช้งานจริง (UAT)',
};

export default function ComingSoonPage({ title, milestone }: { title: string; milestone: string }) {
  return (
    <>
      <PageHeader title={title} />
      <Card>
        <p>
          หน้านี้จะมาใน <b>{milestone}</b>
        </p>
        <p className="mt-1 text-sm text-muted">{PLAN[milestone]}</p>
      </Card>
    </>
  );
}
